
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon weather-stars","d":"M0 40a8.12 8.12 0 007.74-8.07 8 8 0 007.7 8.07 8.05 8.05 0 00-7.7 8.08 7.63 7.63 0 00-2.26-5.6A7.87 7.87 0 000 40zm7.74-23.93a15.31 15.31 0 0010.66-4.89A15.2 15.2 0 0022.78.28a15.2 15.2 0 004.4 10.9 15.39 15.39 0 0010.7 4.9 15.47 15.47 0 00-7.61 2.36 16 16 0 00-5.48 5.73 15.63 15.63 0 00-2 7.74 15.91 15.91 0 00-15-15.85zm11 35.79A11.88 11.88 0 0030.11 40 11.87 11.87 0 0041.4 51.86a11.86 11.86 0 00-11.29 11.86 11.47 11.47 0 00-3.29-8.21 11.63 11.63 0 00-8.05-3.65zM41.4 36.11a11.82 11.82 0 0011.27-11.9A11.88 11.88 0 0064 36.07a11.86 11.86 0 00-11.33 11.86A11.76 11.76 0 0041.4 36.1z"}})])
          )
        }
      }
    